(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.lang = {
    attach: function (context, settings) {
      once('lang', 'ul.language-switcher-language-url', context).forEach(function (block) {
        if (window.matchMedia("(min-width: 1216px)").matches) {

          var container = $(block);
          var activeLang = container.find('li.is-active a').text();

          if(activeLang == '') {
            const params = window.location.pathname.split('/');
            var activeLang = params[1];
          }

          // create span with active lang
          container.parent().prepend('<span class="label">'+activeLang+'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
            '\t viewBox="0 0 6 4" xml:space="preserve">\n' +
            '<path d="M3,4L0,0h6L3,4z"/>\n' +
            '</svg>\n');

          // hide  active lang in ul
          container.find('li.is-active').remove();

          //show ul
          container.parent().find('.label').on('click', function (){
            container.slideToggle(300);
            $(this).find('.fa').toggleClass('fa-caret-down').toggleClass('fa-caret-up');
          });

          //hide ul
          $(document).on('click', function(e) {
            var $clicked = $(e.target);
            if (!$clicked.parents().hasClass("languages")) {
              container.slideUp(300);
              container.parent().find('.label').find('.fas').removeClass('fa-angle-up');
              container.parent().find('.label').find('.fas').addClass('fa-angle-down');
            }
          });

          $(document).scroll(function() {
            if ($(document).scrollTop() > 60) {
              container.slideUp(300);
              container.parent().find('.label').find('.fas').removeClass('fa-angle-up');
              container.parent().find('.label').find('.fas').addClass('fa-angle-down');
            }
          });


        }



      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
